export default __webpack_public_path__ + "static/media/announcement_2@2x.62906a1c.png";